import React from "react";
import MaintenancePage from "./MaintenancePage";

function UnderMaintenanceCommon({ isFromBrowser }) {
  return (
    <MaintenancePage
      isFromBrowser={isFromBrowser}
      customClass="under-maintenance-wrapper"
      isUnderMaintenance={true}
    />
  );
}

export default UnderMaintenanceCommon;
